Vue.directive('lazyload', {
    inserted: el => {
        function animate(node) {
            let lineHeight = node.querySelector('.about-analytics__digit').offsetHeight;

            node.querySelectorAll('.about-analytics__digit-clmn').forEach((elem, i) => {
                let activeNumIndex = [...elem.querySelectorAll('div')].indexOf(elem.querySelector('.active'));

                elem.style.marginTop = lineHeight * -1 * activeNumIndex + 'px';
                elem.style.transition = `2s ease-out  .${i}s`;
            });
        }

        function handleIntersect(entries, observer) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    animate(el)
                    observer.unobserve(el);
                }
            });
        }

        function createObserver() {
            const options = {
                root: null,
                threshold: "0"
            };
            const observer = new IntersectionObserver(handleIntersect, options);
            observer.observe(el);
        }

        function splitNumber(node) {
            const stringNumber = node.textContent.trim().split(' ').join('');
            const digitsNumArr = [...stringNumber].reverse();

            while (node.firstChild) {
                node.removeChild(node.firstChild);
            }

            createDigitColumns(digitsNumArr, node);
        }

        function createDigitColumns(entries, node) {
            entries.forEach((d, i) => {
                const digitCol = document.createElement("div");

                digitCol.className = "about-analytics__digit-clmn";
                node.insertBefore(digitCol, node.children[0]);

                let digitColArr = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

                let digitColIndex = digitColArr.indexOf(+d);
                let columnDigits = [...digitColArr.slice(digitColIndex + 1), ...digitColArr.slice(0, digitColIndex + 1)];

                columnDigits.forEach(digit => {
                    const digitEl = document.createElement("div");

                    digitEl.className = "about-analytics__digit";
                    digitEl.textContent = digit;
                    digitCol.appendChild(digitEl);
                });

                let activeNum = [...digitCol.querySelectorAll('div')].find(num => num.innerText == d);

                activeNum.classList.add('active');
            });
        }
        splitNumber(el);
        if (window["IntersectionObserver"]) {
            createObserver();
        } else {
            animate(el)
        }
    }
})
